// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/fonts.css';
import UtilsPlugin from './plugins/utils';
import 'animate.css';

// Create the app instance
const app = createApp(App);

// Use the router
app.use(router);

// Install the utils plugin
app.use(UtilsPlugin);

// Mount the app
app.mount('#app');

// Keep the URL as the root URL after every navigation
router.afterEach((to) => {
  setTimeout(() => {
    window.history.replaceState({}, document.title, '/');
  }, 0);
});